export default __webpack_public_path__ + "static/media/silver-medal.179ca7e0.png";